module.exports = __webpack_public_path__ + "img/858-057be2.png";